import { useAdition } from '../../../components/Advertising/Adition/useAdition.js';
// @FIXME find a better name
export const AditionConditional = ({
  children
}) => {
  const {
    enabled
  } = useAdition();
  return enabled ? children : null;
};